import React, { FC, ReactElement, useContext, useMemo } from 'react';
import { Box, Button, Paragraph, ResponsiveContext, Text } from 'grommet';
import { FormCheckmark } from 'grommet-icons';
import { ThemeModeImage } from '@/components/ThemeModeImage';

const CheckItem: FC<{ label: string }> = ({ label }): ReactElement => (
  <Box direction="row" gap="small">
    <FormCheckmark color="status-error" />
    <Text>{label}</Text>
  </Box>
);

export const IntelligentScanResults: FC = (): ReactElement => {
  const size = useContext(ResponsiveContext);
  const isSmall = useMemo(() => size === `small`, [size]);
  return (
    <Box direction={isSmall ? `column-reverse` : `row`} pad="medium">
      <Box margin="medium">
        <Text size="xxlarge" margin={{ top: `small` }} weight="bold">
          Industry Specific & Powerful Reports
        </Text>
        <Paragraph>
          Different industries require different needs. Our team has experience
          working in Healthcare, Financial Services, Legal, and with Software
          Companies.
        </Paragraph>
        <Box gap="small">
          <CheckItem label="Maintain HIPAA Compliance" />
          <CheckItem label="Protect Sensitive Data" />
          <CheckItem label="Find Vulnerabilities Before Attackers Do" />
        </Box>
        <Box alignSelf="start">
          <Button
            primary
            href="#cta"
            color="brand"
            label="Start Free Scan"
            margin={{ top: `medium` }}
          />
        </Box>
      </Box>
      <Box animation="slideLeft">
        <ThemeModeImage src="/img/widgets.svg" />
      </Box>
    </Box>
  );
};
